import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common'; // ➔ 追加
import { MatFormFieldModule } from '@angular/material/form-field'; // ➔ 追加
import { MatInputModule } from '@angular/material/input'; // ➔ 追加
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-addresses-form',
  templateUrl: './addresses-form.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
  ],
})
export class AddressesFormComponent {
  @Input() addressesForm!: FormGroup;
  
  
  static createAddressesGroup(): FormGroup {
    return new FormGroup({
      zip: new FormControl("", [Validators.required]),
      prefecture: new FormControl("", [Validators.required]),
      city: new FormControl("", [Validators.required]),
      town: new FormControl("", [Validators.required]),
      line1: new FormControl("", [Validators.required]),
      line2: new FormControl(""),
    });
  }
}

export interface Addresses {
  zip: string | null;
  prefecture: string | null;
  city: string | null;
  town: string | null;
  line1: string | null;
  line2: string | null;
}

export const AddressesDefaultValue = {
    zip: "",
    prefecture : "",
    city: "",
    town: "",
    line1: "",
    line2: "",
}